<template>
    <b-row>
        <b-col cols="12" class="mb-3">
            <h3>ค่าใช้จ่ายเพิ่มเติม</h3>
        </b-col>
        <b-col cols="12">
            <b-table
                :items="listItemJobExpenese"
                :fields="fields"
                responsive
                class="scroll-bar-mkt"
            >
                <template #cell(index)="row">
                    {{ row.index+1 }}
                </template>
                <template #cell(name)="row">
                    {{ row.item.name }}
                </template>
                <template #cell(price)="row">
                    <h3>{{ Number(row.item.price) | number }} บาท</h3>
                </template>
            </b-table>
        </b-col>
    </b-row>
</template>

<script>
import jobServices from "@/api/job.service.js";
export default {
    data(){
        return{
            fields: [
                {
                    key: "index",
                    label: "#",
                    class: 'text-left h5'
                },
                {
                    key: "name",
                    label: "รายละเอียด",
                    class: 'text-left h5'
                },
                {
                    key: "price",
                    label: "ราคา",
                    class: 'text-center h5'
                }
            ],
            listItemJobExpenese: []
        }
    },
    mounted(){
        this.getJobExpenses();
    },
    methods:{
        async getJobExpenses(){
            const { data } = await jobServices.getJobExpenses({job_id: this.$route.params.id})

            if( data.data ){
                this.listItemJobExpenese = data.data.expenses
            }
        }   
    }
}
</script>
